export default "__VITE_ASSET__CDo_gtyy__"